import { AUTH, AUTH_LOGOUT } from '../actions/auth.actions';

let initialState = {
	isLoggedIn: false,
	username: '',
	token: '',
	refreshToken: ''
};

export const authReducer = (state = initialState, action) => {
	switch (action.type) {
		case AUTH.SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				username: action.payload.username,
				token: action.payload.token,
				refreshToken: action.payload.refreshToken !== '' && action.payload.refreshToken
			};
		case 'REFRESH_SIGN_IN': // This prevent race conditions when user log-out and log-in with other account
			return {
				...state,
				isLoggedIn: true,
				username: action.payload.username,
				token: action.payload.token,
				refreshToken: action.payload.refreshToken !== '' && action.payload.refreshToken
			}
		default:
			return state;
	}
};
